export class SafeSend {
  submitRequested = false;
  submitted = false;
  disabled = false;
  fields: unknown;
  formValues: unknown;
  type: SafeSendType = SafeSendType.PROACTIVE;
  safesendInfoArray: SafesendInfo[];
}

export enum SafeSendType {
  PROACTIVE = 'PROACTIVE',
  NORMAL = 'NORMAL',
}

export class SafesendInfo {
  answer: string;
  question: string;
  questionId?: string;
}

export enum SafeSendQuestions {
  ENGLISH_FIRST_NAME = 'First Name',
  FRENCH_FIRST_NAME = 'Prénom',
  ENGLISH_LAST_NAME = 'Last Name',
  FRENCH_LAST_NAME = 'Nom de famille',
  ENGLISH_FULL_NAME = 'First and Last Name',
  FRENCH_FULL_NAME = 'Prénom et nom de famille',
}
